import { AppPartType } from "@lhd/features/Apps/AppForm/types";
import { Styles } from "./styled";
import { useFetchRecordV2 } from "@lhd/hooks";
import { Spin } from "antd";
import { useMemo } from "react";
import { CONTRACT_STATUS } from "@lhd/types";
import { getStatusContractText } from "../../untils";
interface IProps {
  item: AppPartType;
  appType: string;
  appId: string;
  recordId: string;
  namePath: string | string[];
  parentItem?: AppPartType;
  isDisabled?: boolean;
  isTable?: boolean;
  preview?: boolean;
  isPDF?: boolean;
  styleColor?: React.CSSProperties;
}

const StatusContact = (props: IProps) => {
  const { item, appType, appId, recordId } = props;
  const { data: recordDataRaw, isSuccess: isSuccessRecord } = useFetchRecordV2({
    appType,
    appId,
    recordId,
  });

  const contractStatus = useMemo(() => {
    if (!recordId) {
      return CONTRACT_STATUS.DRAFTING;
    }

    if (isSuccessRecord) {
      return recordDataRaw?.data?.contract_info?.contract_status;
    }

    return undefined;
  }, [isSuccessRecord, recordDataRaw, recordId]);

  return (
    <Styles id={item.id} style={{ fontWeight: 700 }}>
      {getStatusContractText(contractStatus || "")}
    </Styles>
  );
};
export default StatusContact;
